import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import {cn} from 'spa/css';

import './PressFeatured.less';

@withI18n
class PressFeaturedFR extends React.Component {
  static propTypes = {
    isAmpPage: PropTypes.bool,
    smallLogos: PropTypes.bool,
  };

  render() {
    const {i18n} = this.context;
    const {isAmpPage, smallLogos} = this.props;

    return (
      <div className="press-featured__press-container container">
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered">
          <ProgressiveImage
            alt={i18n._x('Vogue Magazine logo', 'Press image alt text in the homepage')}
            className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
            disableWebp
            height="30"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/elle.svg"
            isAmpPage={isAmpPage}
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/elle.svg"
            width="101"
          />
        </div>
        <div className="press-featured__press-element">
          <ProgressiveImage
            alt={i18n._x('The Telegraph Newspaper logo', 'Press image alt text in the homepage')}
            className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
            disableWebp
            height="32"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/europe1.svg"
            isAmpPage={isAmpPage}
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/europe1.svg"
            width="89"
          />
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered press-featured__press-element--mobile-top-bottom-border">
          <ProgressiveImage
            alt={i18n._x('The Guardian Newspaper logo', 'Press image alt text in the homepage')}
            className="press-featured__press-image"
            disableWebp
            height="28"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/lefigaro.svg"
            isAmpPage={isAmpPage}
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/lefigaro.svg"
            width="100"
          />
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-top-bottom-border">
          <ProgressiveImage
            alt={i18n._x('Timeout Magazine logo', 'Press image alt text in the homepage')}
            className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
            disableWebp
            height="31"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/leparisien.svg"
            isAmpPage={isAmpPage}
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/leparisien.svg"
            width="111"
          />
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered press-featured__press-element--last">
          <ProgressiveImage
            alt={i18n._x('TechCrunch logo', 'Press image alt text in the homepage')}
            className={cn(smallLogos ? 'press-featured__press-image' : 'press-featured__press-image--medium')}
            disableWebp
            height="44"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493913190/home-fr/m6.svg"
            isAmpPage={isAmpPage}
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493913190/home-fr/m6.svg"
            width="57"
          />
        </div>
      </div>
    );
  }
}

export default PressFeaturedFR;



// WEBPACK FOOTER //
// ./spa/Pages/Home/PressFeaturedFR.jsx